// For English version, no conversion is needed
// Keeping the functions for compatibility but they just return the original text

// Convert text (no conversion needed for English)
export const convertToSimplified = (text) => {
  return text; // No conversion needed for English
};

// Convert text (no conversion needed for English)
export const convertToTraditional = (text) => {
  return text; // No conversion needed for English
};

// Convert example data between languages (no conversion needed for English)
export const convertExampleData = (exampleData, targetLanguage) => {
  if (!exampleData) return exampleData;
  
  // For English version, just return the original data
  return exampleData;
};
